import TagManager from 'react-gtm-module';
import { HashRouter } from 'react-router-dom';
import { GTM_ID } from './helpers/consts';
import { NavigationInbound } from './hooks/useNavigationInbound';
import { NavigationSync } from './hooks/useNavigationSync';
import { MainView } from './modules/MainView';
import { AppContextProviders } from './providers/AppContextProviders';
import './style.global.css';
import './providers/TourProvider/driver.css';

const tagManagerArgs = {
  gtmId: GTM_ID,
};

TagManager.initialize(tagManagerArgs);

export const App = () => (
  <HashRouter>
    <NavigationSync />
    <NavigationInbound />
    <AppContextProviders>
      <MainView />
    </AppContextProviders>
  </HashRouter>
);
